/**
 * Maps user preference interests → post categories and alert kinds.
 * Used to highlight ("For you") matching content and offer a filter toggle.
 */
export const INTEREST_TO_POST_CATEGORIES = {
  recommend: ["help"],
  events: ["meetup"],
  family: ["lost_found"],
  // "community", "food", "wellness", "marketplace", "safety", "utility"
  // are covered on other pages or via alert kinds
};

export const INTEREST_TO_ALERT_KINDS = {
  safety: ["security"],
  utility: ["utility", "road"],
};

/**
 * One-tap topic chips for the community feed.
 * `all` is a sentinel meaning "no filter".
 */
export const FEED_TOPICS = [
  { id: "all",        label: "All",             emoji: "✦" },
  { id: "community",  label: "Community",       emoji: "☺" },
  { id: "help",       label: "Recommendations", emoji: "✦" },
  { id: "meetup",     label: "Meetups",         emoji: "◆" },
  { id: "lost_found", label: "Lost & Found",    emoji: "◇" },
];

export function postMatchesTopic(post, topicId) {
  if (!topicId || topicId === "all") return true;
  return (post?.category || "community") === topicId;
}

export function postMatchesInterests(post, interests) {
  if (!post || !interests || interests.length === 0) return false;
  const cat = post.category || "community";
  return interests.some((i) => (INTEREST_TO_POST_CATEGORIES[i] || []).includes(cat));
}

export function alertMatchesInterests(alert, interests) {
  if (!alert || !interests || interests.length === 0) return false;
  const kind = alert.kind;
  return interests.some((i) => (INTEREST_TO_ALERT_KINDS[i] || []).includes(kind));
}
